import React from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import { Login } from "@features/auth";
import PrivateRoutes, {
  RoleProtectedRoute,
} from "@components/shared/PrivateRoutes";
import DevnagriValidatorAdminLayout from "@components/tables/devnagriValidatorAdmin/ValidatorDevnagriAdminLayout";
import ManageUsersTableDevnagriValidatorAdmin from "@components/tables/devnagriValidatorAdmin/ManageUsersTableDevnagriValidatorAdmin";
import UnauthorizedPage from "@components/shared/UnauthorizedPage";
import TranslatorAdminLayout from "@components/shared/TranslatorAdminLayout";
import ValidatorAdminLayout from "@components/shared/ValidatorAdminLayout";
import ProjectDetailTableCommon from "@components/tables/ProjectDetailTableCommon";
import FolderDetailTableCommon from "@components/tables/FolderDetailTableCommon";
import FileDetailTableTranslator from "@components/tables/translator/FileDetailTableTranslator";
import SentenceTranslationTable from "@components/tables/translator/SentenceTable";
import FileDetailTableTranslatorAdmin from "@components/tables/translatoradmin/FileDetailTableTranslatorAdmin";
import FileDetailTableValidatorAdmin from "@components/tables/validatoradmin/FileDetailTableValidatorAdmin";
import ProjectDetailTableValidatorAdmin from "@components/tables/validatoradmin/ProjectDetailTableValidatorAdmin";
import FolderDetailTableValidatorAdmin from "@components/tables/validatoradmin/FolderDetailTableValidatorAdmin";
import ProjectDetailTableDevnagriValidatorAdmin from "@components/tables/devnagriValidatorAdmin/ProjectDetailTableDevnagriValidatorAdmin";
import FolderDetailTableDevnagriValidatorAdmin from "@components/tables/devnagriValidatorAdmin/FolderDetailTableDevnagriValidatorAdmin";
import FileDetailTableDevnagriValidatorAdmin from "@components/tables/devnagriValidatorAdmin/FileDetailTableDevnagriValidatorAdmin";
import FileDetailTableValidator from "@components/tables/validator/FileDetailTableValidator";
import ProjectDetailTableValidator from "@components/tables/validator/ProjectDetailTableValidator";
import FolderDetailTableValidator from "@components/tables/validator/FolderDetailTableValidator";
import SentenceValidationTable from "@components/tables/validator/SentenceValidationTable";
import ValidatorLayout from "@components/shared/ValidatorLayout";
import GACSAdminLayout from "@components/shared/GACSAdminLayout";
import ProjectDetailTableGAAdmin from "@components/tables/GAAdmin/ProjectDetailTableGAAdmin";
import FolderDetailTableGAAdmin from "@components/tables/GAAdmin/FolderDetailTableGAAdmin";
import FileDetailTableGAAdmin from "@components/tables/GAAdmin/FileDetailTableGAAdmin";
import SentenceDetailTableGAAdmin from "@components/tables/GAAdmin/SentenceDetailTableGAAdmin";
import ManageUsersTableGAAdmin from "@components/tables/GAAdmin/ManageUsersTableGAAdmin";
import DevnagriValidatorLayout from "@components/tables/devnagriValidator/DevnagriValidatorLayout";
import ProjectDetailTableDevnagriValidator from "@components/tables/devnagriValidator/ProjectDetailTableDevnagriValidator";
import FolderDetailTableDevnagriValidator from "@components/tables/devnagriValidator/FolderDetailTableDevnagriValidator";
import FileDetailTableDevnagriValidator from "@components/tables/devnagriValidator/FileDetailTableDevnagriValidator";
import SentenceValidationTableDevnagriValidator from "@components/tables/devnagriValidator/SentenceValidationTableDevnagriValidator";
import SentenceDetailTableDevnagriValidatorAdmin from "@components/tables/devnagriValidatorAdmin/SentenceDetailTableDevnagriValidatorAdmin";
import SuperAdminDashboard from "@components/tables/superadmin/SuperAdminDashboard";
import GAProjectTable from "@components/tables/superadmin/GAProjectTable";
import DevnagriProjectTable from "@components/tables/superadmin/DevnagriProjectTable";
import GAFolderTable from "@components/tables/superadmin/GAFolderTable";
import DevnagriFolderTable from "@components/tables/superadmin/DevnagriFolderTable";
import GAFileTable from "@components/tables/superadmin/GAFileTable";
import { DevnagriFileTable } from "@components/tables/superadmin/DevnagriFileTable";
import GASentenceTable from "@components/tables/superadmin/GASentenceTable";
import DevnagriSentenceTable from "@components/tables/superadmin/DevnagriSentenceTable";
import SentenceTable from '@components/tables/translatoradmin/SentenceTable';
import SentenceTableValidatorAdmin from '@components/tables/validatoradmin/SentenceTableValidatorAdmin';
import GAValidatedFilesTable from "@components/tables/superadmin/GAValidatedFilesTable";
import GAValidatedFilesSentencesTable from "@components/tables/superadmin/GAValidatedFilesSentencesTable";
import DevnagriValidatedFilesTable from "@components/tables/superadmin/DevnagriValidatedFilesTable";
import DevnagriValidatedFilesSentencesTable from "@components/tables/superadmin/DevnagriValidatedFilesSentencesTable";
import GAValidatedProjectsTable from "@components/tables/superadmin/GAValidatedProjectsTable";
import DevnagriValidatedProjectsTable from "@components/tables/superadmin/DevnagriValidatedProjectsTable";
import GAValidatedFoldersTable from "@components/tables/superadmin/GAValidatedFoldersTable";
import DevnagriValidatedFoldersTable from "@components/tables/superadmin/DevnagriValidatedFoldersTable";
import RegisterUserTableGAAdmin from "@/components/tables/GAAdmin/RegisterUserTableGAAdmin";
import RegisterUserTableDevnagriValidatorAdmin from "@/components/tables/devnagriValidatorAdmin/RegisterUserTableDevnagriValidatorAdmin";
import NotFoundPage from "@/components/shared/NotFoundPage";
import Registeration from "@/features/auth/components/Registration";
import StudentDashboardCards from "@/components/tables/dashboard/StudentDashboardCards";
import MyProfile from "@/components/tables/dashboard/MyProfile";
import AboutSangraha from "@/components/shared/AboutSangraha";
import ASR_TTS from "@/components/tables/dashboard/ASR_TTS";
import TTTCard from "@/components/tables/dashboard/TTTCard";
import OCR from "@/components/tables/dashboard/OCR";
import MonolingualInput from "@/components/tables/dashboard/MonolingualInput";
import PrivateRoutesStudent from "@/components/shared/PrivateRoutesStudent";
import LotsForTTT from "@/components/tables/dashboard/LotsForTTT";
import LotsForTTS from "@/components/tables/dashboard/LotsForTTS";
import Dictionary from "@/components/tables/dashboard/Dictionary";
import LotsForDictionary from "@/components/tables/dashboard/LotsForDictionary";


const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/register",
        element: <Registeration />,
      },
      {
        path: "/about-sangraha",
        element: <AboutSangraha />,
      },
      {
        index: true,
        element: <Login />,
      },
      {
        path: "/unauthorized",
        element: <UnauthorizedPage />,
      },
      {
        path: "/forbidden",
        element: <UnauthorizedPage />,
      },
      {
        path: "/not-found",
        element: <UnauthorizedPage />,
      },
      {
        path: "/server-error",
        element: <UnauthorizedPage />,
      },
      {
        element: <PrivateRoutes />,
        children: [
          {
            path: "/superAdmin",
            element: <SuperAdminDashboard />,
            children: [
              { path: "", element: <SuperAdminDashboard /> },
            ],
          },
          {
            path: "/superAdmin/ga",
            children: [
              { path: "", element: <GAProjectTable /> },
              { path: "folders", element: <GAFolderTable /> },
              { path: "folders/files", element: <GAFileTable /> },
              { path: "folders/files/sentences", element: <GASentenceTable /> },
              { path: "approved-projects", element: <GAValidatedProjectsTable /> },
              { path: "approved-projects/folders", element: <GAValidatedFoldersTable /> },
              { path: "approved-projects/folders/approved-files", element: <GAValidatedFilesTable /> },
              { path: "approved-projects/folders/approved-files/sentences", element: <GAValidatedFilesSentencesTable /> },

            ],
          },
          {
            path: "/superAdmin/devnagri",
            children: [
              { path: "", element: <DevnagriProjectTable /> },
              { path: "folders", element: <DevnagriFolderTable /> },
              { path: "folders/files", element: <DevnagriFileTable /> },
              { path: "folders/files/sentences", element: <DevnagriSentenceTable /> },
              { path: "approved-projects", element: <DevnagriValidatedProjectsTable /> },
              { path: "approved-projects/folders", element: <DevnagriValidatedFoldersTable /> },
              { path: "approved-projects/folders/approved-files", element: <DevnagriValidatedFilesTable /> },
              { path: "approved-projects/folders/approved-files/sentences", element: <DevnagriValidatedFilesSentencesTable /> },
            ],
          },
          {
            path: "/GACSAdmin",
            element: (
              <RoleProtectedRoute allowedRoles={["GS ADMIN"]}>
                <GACSAdminLayout />
              </RoleProtectedRoute>
            ),
            children: [
              { path: "", element: <ProjectDetailTableGAAdmin /> },
              { path: "register", element: <RegisterUserTableGAAdmin /> },
              { path: "manage-users", element: <ManageUsersTableGAAdmin /> },
              { path: "folders", element: <FolderDetailTableGAAdmin /> },
              { path: "folders/files", element: <FileDetailTableGAAdmin /> },
              {
                path: "folders/files/sentences",
                element: <SentenceDetailTableGAAdmin />,
              },
            ],
          },
          {
            path: "/translatorAdmin",
            element: (
              <RoleProtectedRoute allowedRoles={["TRANSLATOR ADMIN"]}>
                <TranslatorAdminLayout />
              </RoleProtectedRoute>
            ),
            children: [
              { path: "", element: <ProjectDetailTableCommon /> },
              { path: "folders", element: <FolderDetailTableCommon /> },
              { path: "folders/files", element: <FileDetailTableTranslatorAdmin /> },
              {
                path: "folders/files/sentences/:fileId/:sourceId/:targetId",
                element: <SentenceTable sentences={[]} />,
              },
            ],
          },
          {
            path: "/translator",
            element: (
              <RoleProtectedRoute allowedRoles={["TRANSLATOR USER"]}>
                <TranslatorAdminLayout />
              </RoleProtectedRoute>
            ),
            children: [
              { path: "", element: <ProjectDetailTableCommon /> },
              { path: "folders", element: <FolderDetailTableCommon /> },
              { path: "folders/files", element: <FileDetailTableTranslator /> },
              {
                path: "folders/files/sentences",
                element: <SentenceTranslationTable />,
              },
            ],
          },
          {
            path: "/validatorAdmin",
            element: (
              <RoleProtectedRoute allowedRoles={["VALIDATOR ADMIN"]}>
                <ValidatorAdminLayout />
              </RoleProtectedRoute>
            ),
            children: [
              { path: "", element: <ProjectDetailTableValidatorAdmin /> },
              { path: "folders", element: <FolderDetailTableValidatorAdmin /> },
              { path: "folders/files", element: <FileDetailTableValidatorAdmin /> },
              {
                path: "folders/files/sentences/:fileId/:sourceId/:targetId",
                element: <SentenceTableValidatorAdmin sentences={[]} />,
              }
            ],
          },
          {
            path: "/validator",
            element: (
              <RoleProtectedRoute allowedRoles={["VALIDATOR USER"]}>
                <ValidatorLayout />
              </RoleProtectedRoute>
            ),
            children: [
              { path: "", element: <ProjectDetailTableValidator /> },
              { path: "folders", element: <FolderDetailTableValidator /> },
              { path: "folders/files", element: <FileDetailTableValidator /> },
              { path: "folders/files/sentences", element: <SentenceValidationTable /> },
            ],
          },
          {
            path: "/devnagriValidatorAdmin",
            element: (
              <RoleProtectedRoute allowedRoles={["DEVANAGARI ADMIN"]}>
                <DevnagriValidatorAdminLayout />
              </RoleProtectedRoute>
            ),
            children: [
              { path: "", element: <ProjectDetailTableDevnagriValidatorAdmin /> },
              { path: "register", element: <RegisterUserTableDevnagriValidatorAdmin /> },
              { path: "folders", element: <FolderDetailTableDevnagriValidatorAdmin /> },
              { path: "folders/files", element: <FileDetailTableDevnagriValidatorAdmin /> },
              { path: "folders/files/sentences", element: <SentenceDetailTableDevnagriValidatorAdmin /> },
              { path: "manage-users", element: <ManageUsersTableDevnagriValidatorAdmin /> },
            ],
          },
          {
            path: "/devnagriValidator",
            element: (
              <RoleProtectedRoute allowedRoles={["DEVANAGARI USER"]}>
                <DevnagriValidatorLayout />
              </RoleProtectedRoute>
            ),
            children: [
              { path: "", element: <ProjectDetailTableDevnagriValidator /> },
              { path: "folders", element: <FolderDetailTableDevnagriValidator /> },
              { path: "folders/files", element: <FileDetailTableDevnagriValidator /> },
              { path: "folders/files/sentences", element: <SentenceValidationTableDevnagriValidator /> },
            ],
          },
        ],
      },
      {
        element: <PrivateRoutesStudent />,
        children: [
          {
            path: "/student",
            children: [
              { path: "", element: <StudentDashboardCards /> },
              { path: "lots-for-TTT", element: <LotsForTTT /> },
              { path: "lots-for-TTT/TTT/:lotId", element: <TTTCard /> },
              { path: "lots-for-TTS", element: <LotsForTTS /> },
              { path: "lots-for-TTS/ASR_TTS/:lotId", element: <ASR_TTS /> },
              { path: "OCR", element: <OCR /> },
              { path: "lots-for-Dictionary", element: <LotsForDictionary /> },
              { path: "lots-for-Dictionary/dictionary/:lotId", element: <Dictionary /> },
              { path: "monolingual-input", element: <MonolingualInput /> },
              { path: "my-profile", element: <MyProfile /> },
            ],
          },
          {
            path: "/reviewer",
            children: [
              { path: "", element: <StudentDashboardCards /> },
              { path: "lots-for-TTT", element: <LotsForTTT /> },
              { path: "lots-for-TTT/TTT/:lotId", element: <TTTCard /> },
              { path: "lots-for-TTS", element: <LotsForTTS /> },
              { path: "lots-for-TTS/ASR_TTS/:lotId", element: <ASR_TTS /> },
              { path: "OCR", element: <OCR /> },
              { path: "lots-for-Dictionary", element: <LotsForDictionary /> },
              { path: "lots-for-Dictionary/dictionary/:lotId", element: <Dictionary /> },
              { path: "monolingual-input", element: <MonolingualInput /> },
              { path: "my-profile", element: <MyProfile /> },
            ],
          }
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
]);

export default appRouter;
